import React from 'react';
import Table from 'app/components/common/Table';
import classNames from 'classnames/bind';
import { numberWithCommas } from 'app/libs/number';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import styles from './PaymentAdjustmentDetail.module.scss';

const cx = classNames.bind(styles);

function PaymentAdjustmentDetail({ adjustmentApprovedCount = 0, adjustmentAmount = 0, adjustmentDeniedCount = 0 }) {
	const ua = useSsrUserAgent();
	// 반응형 스타일
	const colWidth = ua().isPc ? '198px' : '140px';
	const isEmpty = adjustmentApprovedCount === 0 && adjustmentDeniedCount === 0;
	return (
		<>
			<div className={cx('box_detail_service')}>
				<h3 className={cx('tit_cont')}>차량별 조정내역</h3>
				<Table
					type="row"
					caption="차량별 조정내역"
					tableAlign="right"
				>
					<colgroup>
						<col style={{ width: colWidth }} />
						<col />
						<col />
					</colgroup>
					<thead>
						<tr>
							<th>상태</th>
							<th className={cx('cellalign_right')}>조정대수</th>
							<th className={cx('cellalign_right')}>조정금액</th>
						</tr>
					</thead>
					<tbody>
						{isEmpty && (
							<tr>
								<td>-</td>
								<td className={cx('cellalign_right')}>-</td>
								<td className={cx('cellalign_right')}>-</td>
							</tr>
						)}
						{!isEmpty && (
							<>
								<tr>
									<td>조정 승인 차량</td>
									<td className={cx('cellalign_right')}>{adjustmentApprovedCount}대</td>
									<td className={cx('cellalign_right')}>{adjustmentAmount ? `-${numberWithCommas(adjustmentAmount)}` : '0'}원</td>
								</tr>
								<tr>
									<td>조정 미승인 차량</td>
									<td className={cx('cellalign_right')}>{adjustmentDeniedCount}대</td>
									<td className={cx('cellalign_right')}>-</td>
								</tr>
							</>
						)}
					</tbody>
				</Table>
			</div>
		</>
	);
}

export default PaymentAdjustmentDetail;
